import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material"
import { styles } from "../styles/TeensLicenseModal.styles"
import { useTranslation } from "react-i18next"
import { useLicenceContext } from "../../../contexts/LicenceContext"
import LockIcon from "@mui/icons-material/Lock"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import { maxHeight600, maxWidth600 } from "themes/default/breakpoints"
import FeatureItem from "../FeatureItem"
const smashorImg = require("assets/img/auth/smasher-01.gif")

const priceFormat = (price) => {
  if (!price) return ""
  return price.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export default function TeensLicenseModal({ open, onClose, licenceType }) {
  const { t } = useTranslation()
  const {
    licenceDaysLeft,
    orderData,
    openInvoice,
    productPrice,
    currencyCode,
  } = useLicenceContext()
  const matches = useMediaQuery(maxHeight600)
  const mobile = useMediaQuery(maxWidth600)

  const titleText = t("license_payment_title_secondary_01") || ""
  const titleWords = titleText.trim().split(/\s+/)
  const hasMultipleWords = titleWords.length > 2
  const mainTitleText = hasMultipleWords
    ? titleWords.slice(0, -2).join(" ")
    : titleText
  const highlightedTitleText = hasMultipleWords
    ? titleWords.slice(-2).join(" ")
    : ""

  const subtitleText = t("license_payment_title_secondary_02") || ""
  const subtitleWords = subtitleText.trim().split(/\s+/)
  const hasMultipleSubtitleWords = subtitleWords.length > 3
  const mainSubtitleText = hasMultipleSubtitleWords
    ? subtitleWords.slice(0, -3).join(" ")
    : subtitleText
  const highlightedSubtitleText = hasMultipleSubtitleWords
    ? subtitleWords.slice(-3).join(" ")
    : ""

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: styles.dialog,
      }}
    >
      <Box sx={styles.headerContainer}>
        <Typography component="h2" sx={styles.title}>
          {hasMultipleWords ? (
            <>
              {mainTitleText}{" "}
              <Box component="span" sx={styles.titleHighlight}>
                {highlightedTitleText}
              </Box>
            </>
          ) : (
            titleText
          )}
        </Typography>
        <Typography sx={styles.subtitle}>
          {hasMultipleSubtitleWords ? (
            <>
              {mainSubtitleText}{" "}
              <Box component="span" sx={styles.subtitleHighlight}>
                {highlightedSubtitleText}
              </Box>
            </>
          ) : (
            subtitleText
          )}
        </Typography>
        <Box sx={styles.downwardPointer} />
      </Box>
      <DialogContent sx={styles.content}>
        <Stack direction={!matches ? "column" : "row"} spacing={1}>
          <Box sx={styles.graphicArea}>
            <Box sx={styles.bgCircle} />
            <Box
              component="img"
              src={smashorImg}
              alt="Character"
              sx={styles.mascot}
            />
          </Box>
          <Stack justifyContent={"center"}>
            <Stack
              spacing={1}
              direction={!mobile ? "row" : "column"}
              sx={styles.featuresContainer}
            >
              <FeatureItem
                sx={{ flex: 1 }}
                icon={require("assets/img/licenses/icono6.png")}
                title={t("license_payment_feature_title_secondary_01")}
                description={t(
                  "license_payment_feature_description_secondary_01"
                )}
              />
              <FeatureItem
                sx={{ flex: 1 }}
                icon={require("assets/img/licenses/icono5.png")}
                title={t("license_payment_feature_title_secondary_02")}
                description={t(
                  "license_payment_feature_description_secondary_02"
                )}
              />
              {!matches && (
                <FeatureItem
                  sx={{ flex: 1 }}
                  icon={require("assets/img/licenses/icono4.png")}
                  title={t("license_payment_feature_title_secondary_03")}
                  description={t(
                    "license_payment_feature_description_secondary_03"
                  )}
                />
              )}
            </Stack>
            {matches && (
              <FeatureItem
                icon={require("assets/img/licenses/icono4.png")}
                title={t("license_payment_feature_title_secondary_03")}
                description={t(
                  "license_payment_feature_description_secondary_03"
                )}
              />
            )}
          </Stack>
        </Stack>
        <Box sx={styles.actionsWrapper}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              variant="outlined"
              disableElevation
              onClick={onClose}
              sx={styles.buttonCancel}
            >
              {t("maybe_later")}
            </Button>
            <Button
              variant="contained"
              disableElevation
              color={"primary"}
              onClick={openInvoice}
              startIcon={<LockIcon />}
              sx={styles.buttonConfirm}
            >
              {`${t("pay_now")} - ${
                orderData?.currency || currencyCode
              } ${priceFormat(orderData?.price || productPrice)}`}
            </Button>
          </Stack>
        </Box>
        <Box sx={styles.reminderBanner}>
          <AccessTimeIcon color="primary" />
          <Typography sx={styles.reminderText}>
            {licenceDaysLeft > 0
              ? t(`license_payment_left_days_secondary`, {
                  days: licenceDaysLeft,
                })
              : t(`license_payment_expired_message_secondary`)}
          </Typography>
        </Box>
        <Box sx={styles.footerNote}>
          <LockOutlinedIcon sx={styles.secureIcon} />
          <Typography sx={styles.footerText}>
            {t("secure_payment_encrypted")}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
